import { createElement } from 'react';
import { string, node } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import 'reakit/Paragraph';
import '../Paragraph/styled.js';
import '../Paragraph/index.js';
import { TimelineRow, TimelineBullet, TimelineStep as TimelineStep$1 } from './styled.js';

/* eslint react/prop-types: 0 */

var TimelineStep = function TimelineStep(_ref) {
  var a11yDescriptionId = _ref.a11yDescriptionId,
      a11yTitleId = _ref.a11yTitleId,
      children = _ref.children,
      lineColor = _ref.lineColor,
      progressColor = _ref.progressColor;
  return createElement(TimelineRow, {
    lineColor: lineColor,
    "aria-labelledby": a11yTitleId,
    "aria-describedby": a11yDescriptionId
  }, createElement(TimelineBullet, {
    backgroundColor: progressColor
  }), createElement(TimelineStep$1, {
    "aria-labelledby": a11yTitleId,
    "aria-describedby": a11yDescriptionId
  }, children));
};

var timelineStepPropTypes = {
  a11yDescriptionId: string,
  a11yTitleId: string,
  children: node.isRequired,
  lineColor: string,
  progressColor: string
};
TimelineStep.propTypes = timelineStepPropTypes;
var timelineStepDefaultProps = {
  a11yDescriptionId: undefined,
  a11yTitleId: undefined,
  lineColor: undefined,
  progressColor: 'textTint'
};
TimelineStep.defaultProps = timelineStepDefaultProps; // @ts-ignore

var C = TimelineStep;

export default C;
export { timelineStepDefaultProps, timelineStepPropTypes };
